import { NAR, RAT, REC, REP_IMG, SUB } from "../../../Data/typeDirs"
import { genId } from "../../../utils"

const exportSchema = {
  name: 'exportSchema',
  _id: genId(),
  content: [
    {
      name: 'root',
      type: 'Container',
      displaySettings: { as: 'Container', className: 'report-root-container schema-print-preview' },
      children: [
        {
          name:'categoryRow',
          type: 'Container',
          displaySettings: { as: 'Row', className: 'report-category-row'},
          children: [
            {
              name: 'exportCategories',
              type: 'exportCategories',
              label: 'Category Selector'
            },
          ]
        },
        {
          name:'rec_nar_img_container',
          type: 'Container',
          displaySettings: {as: 'Row', className:"report-narrative-recommendation-row"},
          children: [
            
            {
              name:'recommendationCol',
              type:'Container',
              displaySettings: {as: 'Col', sm: 3, className:"report-recommendation-col"},
              children: [
                {
                  name:RAT,
                  type:RAT,
                  label:RAT
                },
                {
                  name: REC,
                  type: REC,
                  label: 'Recommendations',
                  parent: SUB
                },
              ]
            },
            {
              name: 'narrativeImageCol',
              type: 'Container',
              displaySettings: {as: 'Col', sm: 9, className: "report-narrative-col"},
              children:[
                {
                  name: `exportNarratives`,
                  type: `exportNarratives`,
                  label: 'Narrative',
                  parent: SUB
                },
                {
                  name: REP_IMG,
                  type: REP_IMG,
                  label: 'Narrative related images'
                }
              ]
            }
          ]
        },
        
      ]
    },

  ]
}

export { exportSchema }